enum ProjectMemberPosition {
  techLead = 'tech-lead',
  accountManager = 'account-manager',
  employee = 'employee',
}

export default ProjectMemberPosition;
